var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from 'react';
var RightDrawerContext = createContext({
    registerRightDrawer: function () { },
});
export var useRightDrawer = function () { return useContext(RightDrawerContext); };
export var RightDrawerProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), opener = _b[0], setOpener = _b[1];
    var registerRightDrawer = useCallback(function (fn) {
        setOpener(function () { return fn; });
    }, []);
    return (_jsx(RightDrawerContext.Provider, __assign({ value: {
            openRightDrawer: opener || undefined,
            registerRightDrawer: registerRightDrawer
        } }, { children: children })));
};
